<!--
    描述：岗位管理
    日期：2021/04/28
    作者：zwh
-->
<template>
    <div class="h100">
        <w-split v-model="splitValueL">
            <div class="h100" slot="left">
                <postTreeTable ref="postTreeTable" @row-click="postRowClick"></postTreeTable>
            </div>
            <div class="h100" slot="right">
                <wSplitRight v-model="splitValueR">
                    <div class="h100" slot="left">
                        <menuTree ref="menuTree"  @row-click="menuRowClick"></menuTree>
                    </div>
                    <div class="h100" slot="right">
                        <btnTree ref="btnTree"></btnTree>
                    </div>
                </wSplitRight>
            </div>
        </w-split>
    </div>
</template>
<script>
import wSplit from '@/components/split/split'
import wSplitRight from '@/components/split/split'
import postTreeTable from './components/post_tree_table'
import menuTree from './components/menu_tree'
import btnTree from './components/btn_tree'
export default {
    name : '',
    components: {
        wSplit,
        wSplitRight,
        postTreeTable,
        menuTree,
        btnTree,
    },
    data() {
        return {
            splitValueL: 0.33,
            splitValueR: 0.5,

            clickPostObj : '',
            clickMenuObj : '',
        }
    },
    mounted() {},
    computed: {},
    watch: {},
    created() {},
    methods: {
        postRowClick(e){
            this.clickPostObj = e

            this.menuRowClick('')
            let obj = {postId : ''}
            if(this.clickPostObj != '') obj.postId = this.clickPostObj.id

            this.$refs.menuTree.init(obj)
        },
        menuRowClick(e){
            this.clickMenuObj = e

            let obj = {postId : '', menuId : ''}
            if(this.clickPostObj != '') obj.postId = this.clickPostObj.id
            if(this.clickMenuObj != '') obj.menuId = e.id

            //查询按钮列表
            this.$refs.btnTree.init(obj)
        },
    }
}
</script>
<style lang="less">

</style>